import { SignRequest } from '@bitte-ai/types';
import { Hex, hashMessage, hashTypedData, keccak256 } from 'viem';

export function signRequestId(request: SignRequest): Hex {
  switch (request.method) {
    case 'eth_sendTransaction': {
      // Warning: This is not a Transaction Hash!
      // Transaction hashes can only be computed after all the fields are filled in (e.g. gas, nonce, etc.)
      // For an Identifier, we will use all transactions in params
      const txData = request.params.map((tx) => ({
        ...tx,
        chainId: request.chainId,
      }));
      return keccak256(new TextEncoder().encode(JSON.stringify(txData)));
    }
    // All other cases actually return the hashToSign.
    case 'personal_sign':
      return hashMessage(request.params[0]);

    case 'eth_sign':
      return keccak256(request.params[1]);

    case 'eth_signTypedData':
    case 'eth_signTypedData_v4': {
      const typedData = JSON.parse(request.params[1]);
      return hashTypedData({
        domain: typedData.domain,
        types: typedData.types,
        primaryType: typedData.primaryType,
        message: typedData.message,
      });
    }

    default:
      throw new Error(`Unsupported method: ${(request as any).method}`);
  }
}
